<template>
  <el-row>
    <el-col :xs="24" :sm="14" style="margin: 50px auto;">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="left">
            <div class="footer-logo">
              <img
                  src="@/assets/bottomlogo.png"
                />
            </div>
            <div class="footer-title">Copyright © 2025 柚优品 版权所有       </div>
            <div class="footer-other" @click="openUrl">
              <img
                  src="@/assets/hui.png"
                />
              <label>沪ICP备2025141004号-1</label>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="qr">
            <img
                src="@/assets/ma.jpg"
              />
            <div class="qr-desc">
              <div>关注柚优品公众号</div>
              <div>更多福利等着你</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'MyFooter',
  
  methods: {
    openUrl() {
      window.open('https://beian.miit.gov.cn', '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-row {
    background-color: #161616;
}
.left {
  text-align: left;
  line-height: 27px;
  .footer-logo img {
    width: 118px;
  }
  .footer-title {
    font-size: 20px;
    margin: 40px 0 35px;
  }
  .footer-other {
    justify-items: center;
    display: flex;
    img {
      width: 27px;
      height: 25px;
    }
  }
}
.qr {
  width: 168px;
  text-align: center;
  margin-left: auto;
  img {
    width: 92px;
  }
  .qr-desc {
    font-size: 20px;
  }
}

@media (max-width: 1920px) {
  .left {
    .footer-logo img {
      width: 79px !important;
    }
    .footer-title {
      font-size: 16px;
      margin: 27px 0 23px !important;
    }
    .footer-other {
      img {
        width: 20px;
      }
    }
  }
  .qr {
    img {
      width: 70px;
    }
    .qr-desc {
      font-size: 16px;
    }
  }

}
</style>
